/**
 * 
 * key
 * 
 */


const key = 'bWVzc2FnZV90ZW1wbGF0ZV9ncm91cA=='

export default key 